const PreviousResidence = {
  name: 'previousResidence',
  title: 'PREVIOUS RESIDENCE',
  container: 'collapse',
  GridProps: { xs: 12 },
  fields: [
    {
      variant: 'text',
      name: 'previousResidenceStreetAddress',
      label: 'Street Address',
      GridProps: { xs: 12, sm: 4 },
    },
    {
      variant: 'text',
      name: 'previousResidenceCity',
      label: 'City',
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'singleSelect',
      name: 'previousResidenceState',
      label: 'State/Province',
      placeholder: 'Select',
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'previousResidenceZipCode',
      label: 'Zip Code/Postal Code',
      GridProps: { xs: 12, sm: 2 },
    },
    {
      variant: 'date',
      name: 'previousResidenceMoveInDate',
      label: 'Move-In Date',
      placeholder: 'MM/DD/YYYY',
      rules: {
        validate: (value) => {
          if (value && value > new Date()) {
            return 'Move-in date cannot be a future date';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 2 },
    },
    {
      variant: 'currency',
      name: 'previousResidenceMonthlyPayments',
      label: 'Current Monthly Payments',
      rules: {
        min: 0,
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'flexSpacer',
    },
    {
      name: 'previousOwnOrRentDetails',
      title: 'OWN OR RENT DETAILS',
      titleVariant: 'collapse',
      container: 'default',
      fields: [
        {
          variant: 'radioGroup',
          name: 'previousResidenceOwnOrRent',
          label: 'Do you currently Own or Rent your property?',
          options: [
            { label: 'Own', value: 'own' },
            { label: 'Rent', value: 'rent' },
            { label: 'Do not currently Own/Rent', value: 'other' },
          ],
          sx: {
            flexDirection: 'row',
          },
          GridProps: { xs: 12, marginTop: 2 },
        },
        {
          variant: 'text',
          name: 'previousResidenceLenderName',
          label: 'Lender Name',
          rules: {
            required: true,
          },
          watchFields: ['previousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('previousResidenceOwnOrRent') !== 'own',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'phone',
          name: 'previousResidenceLenderPhone',
          label: 'Phone Number',
          placeholder: '(000) 000-0000',
          rules: {
            required: true,
          },
          watchFields: ['previousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('previousResidenceOwnOrRent') !== 'own',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'text',
          name: 'previousResidenceLandlordName',
          label: 'Landlord/Condo/Apartment Name',
          rules: {
            required: true,
          },
          watchFields: ['previousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('previousResidenceOwnOrRent') !== 'rent',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'phone',
          name: 'previousResidenceLandlordPhone',
          label: 'Phone Number',
          placeholder: '(000) 000-0000',
          rules: {
            required: true,
          },
          watchFields: ['previousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('previousResidenceOwnOrRent') !== 'rent',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'text',
          name: 'previousResidenceReason',
          label: 'Reason',
          placeholder: 'Please explain...',
          multiline: true,
          rows: 3,
          rules: {
            required: true,
          },
          watchFields: ['previousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('previousResidenceOwnOrRent') !== 'other',
          GridProps: { xs: 12 },
        },
        {
          variant: 'text',
          name: 'previousResidenceReasonForMoving',
          label: 'Reason for moving',
          placeholder: 'Please explain...',
          multiline: true,
          rows: 3,
          GridProps: { xs: 12 },
        },
      ],
    },
  ],
};

export default PreviousResidence;
